<template>
  <section class="section-main py-1">
    <div
      class="section-main__title is-space-between"
      :class="[isLoading ? '' : 'is-lined']"
    >
      <h2 class="mb-5">
        點數餘額：<span class="balance">{{ balance ? balance : "-" }}</span>
      </h2>
    </div>
    <div class="section-main__content" v-if="isLoading">
      <inline-svg
        :src="require('../../assets/icon/svg/loading.svg')"
        class="loading"
      />
    </div>
    <EarnedPointTable v-else :earned-points="earnedPoints" />
  </section>
</template>
<script>
import EarnedPointTable from "../UI/Table/EarnedPointTable.vue";
import pointsAPI from "../../apis/points";
import dayjs from "dayjs";
export default {
  name: "EarnedPoint.vue",
  data() {
    return {
      currentLastDays: 0,
      isLoading: true,
      earnedPoints: [
        {
          earnedId: "",
          userId: "",
          project: null,
          points: 0,
          balance: 0,
          note: "",
          expiry: "",
          createdTime: "",
        },
      ],
      balance: "",
    };
  },
  components: { EarnedPointTable },
  async mounted() {
    const { cardNo, phoneNumber, page, pageSize, startDate } =
      this.$route.query;
    this.fetchEarnedPoints({
      queryCardNo: cardNo,
      queryPhoneNumber: phoneNumber,
      queryPage: Number(page),
      queryPagesize: Number(pageSize),
      queryStartDate: startDate,
    });
  },
  beforeRouteUpdate(to, from, next) {
    const { cardNo, phoneNumber, page, pageSize, startDate } = to.query;
    this.fetchEarnedPoints({
      queryCardNo: cardNo,
      queryPhoneNumber: phoneNumber,
      queryPage: Number(page),
      queryPagesize: Number(pageSize),
      queryStartDate: startDate,
    });
    next();
  },
  methods: {
    async fetchEarnedPoints({
      queryPage,
      queryPagesize,
      queryCardNo,
      queryPhoneNumber,
      queryStartDate,
    }) {
      try {
        this.isLoading = true;

        let { data, status } = await pointsAPI.earnedPoints.get({
          page: Number(queryPage),
          pagesize: Number(queryPagesize),
          cardno: queryCardNo,
          phonenumber: queryPhoneNumber,
          startdate: queryStartDate,
        });
        if (status !== 200) {
          throw new Error(status);
        }
        let { pointsEarneds } = data;
        const modifiedData = pointsEarneds
          .sort((a, b) => {
            return new Date(b.createdTime) - new Date(a.createdTime);
          })
          .map((point) => {
            return {
              ...point,
              createdTime: dayjs
                .utc(point.createdTime)
                .tz("Asia/Taipei")
                .local()
                .format("YYYY/MM/DD"),
              expiry: dayjs
                .utc(point.expiry)
                .tz("Asia/Taipei")
                .local()
                .format("YYYY/MM/DD"),
            };
          });
        this.earnedPoints = modifiedData;
        this.balance = modifiedData[0].balance.toLocaleString();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.error(error.message);
      }
    },
    switchDays(day) {
      this.currentLastDay = +day;
      const { cardNo, phoneNumber, page, pageSize } = this.$route.query;
      const startDate = this.getStartDate(day);
      this.$router.push({
        name: "EarnedPoint",
        query: {
          cardNo: cardNo,
          phoneNumber: phoneNumber,
          page: Number(page),
          pageSize: Number(pageSize),
          startDate: startDate,
        },
      });
    },
    getStartDate(duration) {
      const startDate = dayjs().subtract(duration, "Day").format("YYYY-MM-DD");
      return startDate;
    },
  },
  watch: {
    earnedPoints(newVal) {
      this.earnedPoints = newVal;
    },
  },
};
</script>
